export default "__VITE_ASSET__DzmAkXyq__"